import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import TeeSheet from "@/pages/TeeSheet";
import Pace from "@/pages/Pace";
import Revenue from "@/pages/Revenue";
import Customers from "@/pages/Customers";
import FnB from "@/pages/FnB";
import ProShop from "@/pages/ProShop";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { isAuthed } = useApp();
  if (!isAuthed) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="tee-sheet" element={<TeeSheet />} />
        <Route path="pace" element={<Pace />} />
        <Route path="revenue" element={<Revenue />} />
        <Route path="customers" element={<Customers />} />
        <Route path="fnb" element={<FnB />} />
        <Route path="pro-shop" element={<ProShop />} />
        <Route path="insights" element={<Insights />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}
